import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { CustomerSupportService } from "@obg/core.customer-support";
import { AlertButtonColor, AlertButtonStyle } from "@obg/mat.ui.core";
import { CommonState } from "@obg/ngx.common";
import {
	AbstractTranslatableAlertService,
	AUTH_MESSAGE_CODES,
	AUTH_MESSAGE_CONTEXT,
	CORE_ROUTE,
	JurisdictionPrefixPipe,
	MessageService,
	MessageType,
} from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

export const SELF_EXCLUDED_CENTRALLY = "SELF_EXCLUDED_CENTRALLY";

@Injectable({
	providedIn: "root",
})
export class LoginErrorService {
	constructor(
		private store: Store<CommonState>,
		private messageService: MessageService,
		private alertService: AbstractTranslatableAlertService,
		private jurisdictionPrefixPipe: JurisdictionPrefixPipe,
		private customerSupportService: CustomerSupportService
	) {}

	selfExcludedLoginMessage$(): Observable<any> {
		return this.messageService
			.consume$({
				context: [AUTH_MESSAGE_CONTEXT.loginWithAuthenticationToken],
				messageType: MessageType.Error,
				messageCode: AUTH_MESSAGE_CODES.login.customerSelfExcluded,
			})
			.pipe(
				tap(() => {
					this.openAlert();
				})
			);
	}

	openAlert() {
		const error = `login.${AUTH_MESSAGE_CODES.login.customerSelfExcluded}`.toLowerCase();
		this.alertService.open(
			{
				hideClose: true,
				dialogConfig: {
					disableClose: true,
					maxWidth: "none",
				},
				variant: "alternate",
				verticalButtons: true,
				id: SELF_EXCLUDED_CENTRALLY,
				title: this.jurisdictionPrefixPipe.transform("login.title.login-error"),
				message: this.jurisdictionPrefixPipe.transform(error),
				buttons: [
					{
						color: AlertButtonColor.Accent,
						style: AlertButtonStyle.Flat,
						text: "customer-interactions.more-information",
						handler: () =>
							this.store.dispatch(RouteAction.navigate(CORE_ROUTE.responsibleGaming.information)),
					},
					{
						color: AlertButtonColor.Primary,
						style: AlertButtonStyle.Stroked,

						text: "general.contact-customer-support",
						handler: () => this.customerSupportService.openSupportPageInNewTab(),
					},
				],
			},
			[]
		);
	}
}
